// 配送日時セクションをカート総額の下に移動
document.addEventListener('DOMContentLoaded', function() {
  const cartBottomTotal = document.querySelector('.cart__bottom-total');
  const deliveryDatetimeSection = document.getElementById('shopify-block-AT1pBekxCbFF3am5SN__amp_delivery_datetime_jbfwq4');

  if (cartBottomTotal && deliveryDatetimeSection) {
    cartBottomTotal.insertAdjacentElement('afterend', deliveryDatetimeSection);
  }
});
